/* unplugin-vue-components disabled */import { render } from "./ModifyRecords.vue?vue&type=template&id=e58e4d26&scoped=true&ts=true"
import script from "./ModifyRecords.vue?vue&type=script&lang=ts"
export * from "./ModifyRecords.vue?vue&type=script&lang=ts"

import "./ModifyRecords.vue?vue&type=style&index=0&id=e58e4d26&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e58e4d26"]])

export default __exports__